import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";
import {CommonStatus} from "@/enums/status";

export class DistrictParams {
    page = 1;
    limit = LIMIT_PAGE_DEFAULT;
    search = undefined;
    status = CommonStatus.Active;
    provinceId = undefined;
}
